// extracted by mini-css-extract-plugin
export default {"wrapper":"kTXF4Vlv","container":"aFMEm9vt","banner":"xfhEXe8v","defaultPlaceholder":"g6kmcItV","desktop":"desktop","pop-up_main_container":"pop-up_main_container","mobile":"mobile"};